import axios, { CancelToken } from 'axios';
import { IReceitaDetalhe, IReceitaPatchPayload, IReceitasConfiguracoes } from '../../../../pages/ConfiguracoesReceitas/interface';
import { GATEWAY_API_URL } from '../../../request/urls';
import { getToken } from "../../../token";

class CodigoReceitasService {
    async getReceitasCodigo(signal?: CancelToken): Promise<Array<IReceitasConfiguracoes>> {
        const { data } = await axios.get(`${GATEWAY_API_URL}/receitas-ipm/receitas/codigos`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async getReceitaByCodigo(codigo: string, signal?: CancelToken): Promise<IReceitaDetalhe> {
        const { data } = await axios.get(`${GATEWAY_API_URL}/receitas-ipm/receitas/codigos/${codigo}`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async getQuantidadeReceitasCodigo(signal?: CancelToken) {
        const { data } = await axios.get(`${GATEWAY_API_URL}/receitas-ipm/receitas/codigos/nao-resolvidas`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async patchReceitasCodigo(codigo: string, payload: IReceitaPatchPayload, signal?: CancelToken) {
        const { data } = await axios.patch(`${GATEWAY_API_URL}/receitas-ipm/receitas/codigos/${codigo}`,
            payload,
            {
                cancelToken: signal,
                headers: {
                    'Authorization': 'Bearer ' + getToken(),

                },
            }
        );
        return data;
    }
}

export default new CodigoReceitasService();
